import { useEffect } from "react";
import confetti from "canvas-confetti";

// Synthesize a confetti "pop + sparkle" sound using Web Audio API.
function playConfettiSound() {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();

    // 1) Pop - short bandpassed noise burst
    const popBuffer = ctx.createBuffer(1, ctx.sampleRate * 0.18, ctx.sampleRate);
    const popData = popBuffer.getChannelData(0);
    for (let i = 0; i < popData.length; i++) {
      const t = i / popData.length;
      popData[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 3);
    }
    const popNoise = ctx.createBufferSource();
    popNoise.buffer = popBuffer;
    const popFilter = ctx.createBiquadFilter();
    popFilter.type = "bandpass";
    popFilter.frequency.value = 1500;
    popFilter.Q.value = 1.2;
    const popGain = ctx.createGain();
    popGain.gain.setValueAtTime(0.6, ctx.currentTime);
    popGain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.18);
    popNoise.connect(popFilter).connect(popGain).connect(ctx.destination);
    popNoise.start();

    // 2) Sparkle - cascade of short high pitched sine blips
    const notes = [880, 1175, 1568, 2093, 2637, 3136];
    notes.forEach((freq, idx) => {
      const start = ctx.currentTime + 0.04 + idx * 0.05;
      const osc = ctx.createOscillator();
      osc.type = "sine";
      osc.frequency.value = freq;
      const g = ctx.createGain();
      g.gain.setValueAtTime(0, start);
      g.gain.linearRampToValueAtTime(0.18, start + 0.01);
      g.gain.exponentialRampToValueAtTime(0.001, start + 0.22);
      osc.connect(g).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.25);
    });

    // 3) Whoosh - low rising sweep
    const sweep = ctx.createOscillator();
    sweep.type = "sawtooth";
    sweep.frequency.setValueAtTime(140, ctx.currentTime);
    sweep.frequency.exponentialRampToValueAtTime(60, ctx.currentTime + 0.25);
    const sweepGain = ctx.createGain();
    sweepGain.gain.setValueAtTime(0.18, ctx.currentTime);
    sweepGain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
    sweep.connect(sweepGain).connect(ctx.destination);
    sweep.start();
    sweep.stop(ctx.currentTime + 0.32);
  } catch (e) {
    // silent fail
  }
}

function blastConfetti() {
  const colors = ["#C4FF3D", "#9FE82A", "#ffffff", "#ffd166", "#06d6a0", "#ef476f"];

  // Center burst
  confetti({
    particleCount: 140,
    spread: 90,
    startVelocity: 55,
    origin: { x: 0.5, y: 0.6 },
    colors,
    scalar: 1.1,
    ticks: 220,
  });

  // Left cannon
  setTimeout(() => {
    confetti({
      particleCount: 90,
      angle: 60,
      spread: 75,
      startVelocity: 60,
      origin: { x: 0, y: 0.7 },
      colors,
      ticks: 220,
    });
  }, 150);

  // Right cannon
  setTimeout(() => {
    confetti({
      particleCount: 90,
      angle: 120,
      spread: 75,
      startVelocity: 60,
      origin: { x: 1, y: 0.7 },
      colors,
      ticks: 220,
    });
  }, 300);

  // Top sprinkle
  setTimeout(() => {
    confetti({
      particleCount: 60,
      spread: 160,
      startVelocity: 35,
      gravity: 0.7,
      origin: { x: 0.5, y: 0 },
      colors,
      ticks: 260,
    });
  }, 500);
}

export default function ConfettiBlast() {
  useEffect(() => {
    // Use a module-level guard to survive React StrictMode double-invocation
    if (window.__vx_confetti_fired) return;
    window.__vx_confetti_fired = true;

    // Fire immediately (no setTimeout so StrictMode cleanup can't cancel it)
    requestAnimationFrame(() => {
      blastConfetti();
      playConfettiSound();
    });

    let soundFired = false;
    const userGesture = () => {
      if (soundFired) return;
      soundFired = true;
      playConfettiSound();
    };
    window.addEventListener("pointerdown", userGesture, { once: true });
    window.addEventListener("keydown", userGesture, { once: true });
    window.addEventListener("scroll", userGesture, { once: true });
  }, []);

  return null;
}
